import { TouchPointHelper } from '../../../helpers/touchPointHelper';
import { placeholders, displayGroups } from '@ui';

export const integratedSolutionSelectSolution = {
	prismName: 'integratedSolutionSelectSolution',
	template: {
		templateName: 'integratedSolutionSelectSolutionTemplate',
		displayGroups: [
			TouchPointHelper.createDisplayGroup(displayGroups.pageContainer, [
				TouchPointHelper.createDisplayGroup(displayGroups.rowContainer, [
					TouchPointHelper.createDisplayGroup(
						displayGroups.leftPanel,
						[],
						[
							TouchPointHelper.createPlaceholder(placeholders.logoBcp, {
								placeholderBuildReference: 10,
							}),
							TouchPointHelper.createPlaceholder(placeholders.wizardMenu, {
								placeholderBuildReference: 100,
							}),
							TouchPointHelper.createPlaceholder(placeholders.doubtsAndExit, {
								placeholderBuildReference: 200,
							}),
						]
					),
					TouchPointHelper.createDisplayGroup(
						displayGroups.columnContainer,
						[
							TouchPointHelper.createDisplayGroup(
								displayGroups.bodyPanel,
								[],
								[
									TouchPointHelper.createPlaceholder(placeholders.enterpriseSolution, {
										placeholderBuildReference: 100,
									}),
								]
							),
						],
						[
							TouchPointHelper.createPlaceholder(placeholders.fixedFooter, {
								placeholderBuildReference: 1000,
							}),
							TouchPointHelper.createPlaceholder(placeholders.modals, {
								placeholderBuildReference: 1001,
							}),
						]
					),
				]),
			]),
		],
	},
};
